import { FormFieldWrapper, message, SimpleInput, useForm } from "@caisy/league";
import { useRouter } from "next/router";
import { FC, useEffect, useState } from "react";
import { useI18nSignUpFlow } from "../../../../provider/i18n/I18nProvider";
import { checkFirebaseLogin, fetchSignInMethodsForEmail } from "../../../../services/firebase";
import { useSignUp } from "../../../../stores/sign-up/useSignUp";
import { RegisterForm } from "../RegisterForm";
import { RegisterFormButton } from "../RegisterFormButton";
import { RegisterFormRichText } from "../RegisterFormRichText";
import { SRegisterFormContent } from "../styles/SRegisterFormContent";
import { SRegisterFormTitle } from "../styles/SRegisterFormTitle";
import { isValidEmail } from "../utils";

const loginImages = (
  <>
    <img src={`/app/static-assets/login/login_bg.svg`} alt="" />
    <img src={`/app/static-assets/login/login_layer_0.svg`} alt="" />
    <img src={`/app/static-assets/login/login_layer_1.svg`} alt="" />
    <img src={`/app/static-assets/login/login_layer_2.svg`} alt="" />
  </>
);

export const SignUpForm: FC = () => {
  const [loading, setLoading] = useState(false);
  const { signUp_formTitle, signUp_buttonContent, signUp_description, signUp_emailInput, signUp_invalidEmail } =
    useI18nSignUpFlow();
  const { createCaisyUser } = useSignUp();
  const { control, handleSubmit, validate, getFieldErrors } = useForm();
  const router = useRouter();

  const checkEmail = async ({ email }: { email: string }) => {
    const methods = await fetchSignInMethodsForEmail({ email });
    // user has already a password
    if (methods.length > 0 && methods.includes("password")) {
      message.error("User already exists");
      await router.push(`/login`, undefined, { shallow: false });
      return;
    }

    if (methods.length === 0 && (await validate())) {
      await createCaisyUser({ email });
      await router.push("/register-confirm-email", undefined, { shallow: true });
    }
  };

  const onSubmit = async (formData: { [identifier: string]: string }) => {
    setLoading(true);
    if (!(await validate())) return setLoading(false);
    const email = `${formData[signUp_emailInput.identifier]}`.trim();

    await checkEmail({ email });
    setLoading(false);
  };

  useEffect(() => {
    checkFirebaseLogin({ router });
  }, []);

  const identifier = signUp_emailInput?.identifier || "email";

  if (!signUp_emailInput?.identifier) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: "calc(50vh - 12px)",
        }}
      >
        <img style={{ width: 24, height: 24 }} src={`/app/static-assets/spinner.gif`} />
      </div>
    );
  }
  return (
    <>
      <RegisterForm images={loginImages} color="blue" onSubmit={handleSubmit(onSubmit)}>
        <SRegisterFormTitle>{signUp_formTitle}</SRegisterFormTitle>
        <SRegisterFormContent>
          <FormFieldWrapper
            rules={[{ name: "email", message: signUp_invalidEmail, condition: (value) => isValidEmail(value) }]}
            control={control}
            name={identifier}
          >
            <SimpleInput
              state={getFieldErrors(identifier)?.length ? "error" : "default"}
              label={getFieldErrors(identifier)?.length ? signUp_invalidEmail : signUp_emailInput?.title || "Email"}
              placeholder={signUp_emailInput?.placeholder ?? "your best email"}
            />
          </FormFieldWrapper>
          <RegisterFormButton loading={loading}>{signUp_buttonContent}</RegisterFormButton>
        </SRegisterFormContent>
        {signUp_description?.json && <RegisterFormRichText alignCenter node={signUp_description.json} />}
      </RegisterForm>
    </>
  );
};
